export enum ReservationApiEnum {
  PosConfigModule = 'rpo-m',
  Reservations = 'reservations',
  Approve = 'approve',
  Reject = 'reject',
}
